import React from "react";
import { LoginForm } from "../../../components/Admin/Auth";
import { Icon } from "../../../assets";
import "./Auth.scss";

export function Auth() {
  return (
    <div className="auth">
      <div className="auth__brand">
        <Icon.LogoWhite className="auth__logo" />
        <p className="auth__tagline">Panel administrador</p>
      </div>
      <div className="auth__card">
        <LoginForm />
      </div>
      <p className="auth__footer">
        © {new Date().getFullYear()} Educa360 · Acceso protegido por
        verificación en dos pasos
      </p>
    </div>
  );
}
